export default {"src":"/_next/static/media/ae.b721301d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};